import React from "react";
import { ShippingMethodInterface } from "../../../intrefaces/credit/shipping-method.interface";
import { ShippingSelected } from "../../../svg/ShippingSelected";
import { useCreditSelector } from "../../../stores/product/product.store";
import { CreditState } from "../../../stores/credit/credit-state.interface";

interface MethodProps {
    method: ShippingMethodInterface;
    isSelected?: boolean;
    onChange?: (method: ShippingMethodInterface) => void;
}

export const Method: React.FC<MethodProps> = ({ method, isSelected = false, onChange }) => {
    const translate = useCreditSelector((state: CreditState) => state.text);
    const price = () => {
        if(method.minPrice === 0 && method.maxPrice === 0) return translate.free;
        if(method.minPrice === method.maxPrice) return `${ method.maxPrice } ${ translate.currency }`;
        return `${ method.minPrice } - ${ method.maxPrice } ${ translate.currency }`;
    }

    const select = () => {
        if(onChange) onChange(method);
    }

    return (
        <div
            className={ `flex rounded-xl bg-light-gray p-4 items-start cursor-pointer ${ isSelected ? 'border-yellow' : 'border-light-gray' } border-2` }
            onClick={ () => select() }>
            <ShippingSelected className={ `${ !isSelected && 'hidden' }` } />
            <img src={ method.icon } alt={ method.name } className={ `${ isSelected && 'hidden' }` }/>
            <div className="ml-2">
                <p className="mb-4">{ method.name }</p>
                <p className="text-gray">{ price() }</p>
            </div>
        </div>
    )
}